module.exports = __webpack_public_path__ + "media/images/emblems/Romanel-sur-Lausanne-coat_of_arms-d6c851e31666135fbf4937896f980e87.svg";